import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class FeatureUsageEventsService {
    private readonly _acquired = new Subject<string>();

    readonly acquired$: Observable<string> = this._acquired.asObservable();

    notifyAcquired(featureName: string): void {
        this._acquired.next(featureName);
    }
}
